import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { UserIcon, SettingsIcon, KeyIcon, BellIcon, CreditCardIcon, LogOutIcon, CheckCircleIcon, MailIcon, PhoneIcon, BuildingIcon, MapPinIcon, ShieldIcon, ClockIcon, FileTextIcon, BarChart2Icon, LockIcon, AlertCircleIcon } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
const UserProfile = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const userData = {
    name: 'Alex Johnson',
    email: 'alex.johnson@example.com',
    phone: '(415) 555-1234',
    role: 'Senior Trader',
    company: 'PhoneAI Market',
    location: 'San Francisco, CA',
    joinDate: 'March 15, 2022',
    lastLogin: 'Today, 9:32 AM',
    status: 'Active',
    avatar: 'AJ',
    verificationStatus: 'Verified',
    twoFactorEnabled: true
  };
  const recentActivity = [{
    id: 1,
    action: 'Logged in',
    timestamp: 'Today, 9:32 AM',
    device: 'Chrome on Windows',
    ipAddress: '192.168.1.1'
  }, {
    id: 2,
    action: 'Updated inventory',
    timestamp: 'Yesterday, 3:45 PM',
    device: 'Chrome on Windows',
    ipAddress: '192.168.1.1'
  }, {
    id: 3,
    action: 'Created new order',
    timestamp: 'July 19, 2023, 11:20 AM',
    device: 'Mobile App on iPhone',
    ipAddress: '192.168.0.5'
  }, {
    id: 4,
    action: 'Changed password',
    timestamp: 'July 15, 2023, 2:10 PM',
    device: 'Chrome on Windows',
    ipAddress: '192.168.1.1'
  }];
  const notificationPreferences = [{
    id: 'email_order',
    category: 'Orders',
    description: 'Order status updates',
    email: true,
    push: true
  }, {
    id: 'email_inventory',
    category: 'Inventory',
    description: 'Low stock alerts',
    email: true,
    push: true
  }, {
    id: 'email_price',
    category: 'Market Prices',
    description: 'Significant price changes',
    email: true,
    push: false
  }, {
    id: 'email_auction',
    category: 'Auctions',
    description: 'Auction alerts and outbid notifications',
    email: true,
    push: true
  }, {
    id: 'email_system',
    category: 'System',
    description: 'System maintenance and updates',
    email: false,
    push: false
  }];
  return <div className="space-y-6" data-id="element-3783">
      <div className="flex items-center justify-between" data-id="element-3784">
        <h1 className="text-2xl font-bold" data-id="element-3785">User Profile</h1>
        <Button variant="outline" data-id="element-3786">
          <LogOutIcon className="mr-2 h-4 w-4" data-id="element-3787" />
          Sign Out
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-3788">
        <Card className="md:col-span-1" data-id="element-3789">
          <CardContent className="p-6" data-id="element-3790">
            <div className="flex flex-col items-center text-center" data-id="element-3791">
              <div className="h-24 w-24 rounded-full bg-primary text-primary-foreground grid place-items-center text-3xl font-medium mb-4" data-id="element-3792">
                {userData.avatar}
              </div>
              <h2 className="text-xl font-bold" data-id="element-3793">{userData.name}</h2>
              <p className="text-sm text-muted-foreground" data-id="element-3794">{userData.role}</p>
              <div className="flex items-center mt-2" data-id="element-3795">
                <Badge variant="success" className="flex items-center" data-id="element-3796">
                  <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-3797" />
                  {userData.verificationStatus}
                </Badge>
              </div>
              <div className="w-full mt-6 space-y-2" data-id="element-3798">
                <Button variant="outline" className="w-full justify-start" data-id="element-3799">
                  <UserIcon className="mr-2 h-4 w-4" data-id="element-3800" />
                  View Profile
                </Button>
                <Button variant="outline" className="w-full justify-start" data-id="element-3801">
                  <SettingsIcon className="mr-2 h-4 w-4" data-id="element-3802" />
                  Account Settings
                </Button>
                <Button variant="outline" className="w-full justify-start" data-id="element-3803">
                  <KeyIcon className="mr-2 h-4 w-4" data-id="element-3804" />
                  Security
                </Button>
                <Button variant="outline" className="w-full justify-start" data-id="element-3805">
                  <BellIcon className="mr-2 h-4 w-4" data-id="element-3806" />
                  Notifications
                </Button>
                <Button variant="outline" className="w-full justify-start" data-id="element-3807">
                  <CreditCardIcon className="mr-2 h-4 w-4" data-id="element-3808" />
                  Billing
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
        <div className="md:col-span-3 space-y-6" data-id="element-3809">
          <Tabs defaultValue="profile" value={activeTab} onValueChange={setActiveTab} data-id="element-3810">
            <TabsList className="mb-4" data-id="element-3811">
              <TabsTrigger value="profile" data-id="element-3812">Profile</TabsTrigger>
              <TabsTrigger value="security" data-id="element-3813">Security</TabsTrigger>
              <TabsTrigger value="notifications" data-id="element-3814">Notifications</TabsTrigger>
              <TabsTrigger value="activity" data-id="element-3815">Activity</TabsTrigger>
            </TabsList>
            <TabsContent value="profile" className="space-y-4" data-id="element-3816">
              <Card data-id="element-3817">
                <CardHeader data-id="element-3818">
                  <CardTitle data-id="element-3819">Personal Information</CardTitle>
                  <CardDescription data-id="element-3820">
                    Manage your personal details
                  </CardDescription>
                </CardHeader>
                <CardContent data-id="element-3821">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3822">
                    <div className="space-y-2" data-id="element-3823">
                      <label htmlFor="name" className="text-sm font-medium" data-id="element-3824">
                        Full Name
                      </label>
                      <input id="name" type="text" className="w-full p-2 rounded-md border bg-background" defaultValue={userData.name} data-id="element-3825" />
                    </div>
                    <div className="space-y-2" data-id="element-3826">
                      <label htmlFor="email" className="text-sm font-medium" data-id="element-3827">
                        Email Address
                      </label>
                      <input id="email" type="email" className="w-full p-2 rounded-md border bg-background" defaultValue={userData.email} data-id="element-3828" />
                    </div>
                    <div className="space-y-2" data-id="element-3829">
                      <label htmlFor="phone" className="text-sm font-medium" data-id="element-3830">
                        Phone Number
                      </label>
                      <input id="phone" type="tel" className="w-full p-2 rounded-md border bg-background" defaultValue={userData.phone} data-id="element-3831" />
                    </div>
                    <div className="space-y-2" data-id="element-3832">
                      <label htmlFor="role" className="text-sm font-medium" data-id="element-3833">
                        Job Role
                      </label>
                      <input id="role" type="text" className="w-full p-2 rounded-md border bg-background" defaultValue={userData.role} data-id="element-3834" />
                    </div>
                    <div className="space-y-2" data-id="element-3835">
                      <label htmlFor="company" className="text-sm font-medium" data-id="element-3836">
                        Company
                      </label>
                      <input id="company" type="text" className="w-full p-2 rounded-md border bg-background" defaultValue={userData.company} data-id="element-3837" />
                    </div>
                    <div className="space-y-2" data-id="element-3838">
                      <label htmlFor="location" className="text-sm font-medium" data-id="element-3839">
                        Location
                      </label>
                      <input id="location" type="text" className="w-full p-2 rounded-md border bg-background" defaultValue={userData.location} data-id="element-3840" />
                    </div>
                  </div>
                </CardContent>
                <CardFooter className="border-t" data-id="element-3841">
                  <Button className="ml-auto" data-id="element-3842">Save Changes</Button>
                </CardFooter>
              </Card>
              <Card data-id="element-3843">
                <CardHeader data-id="element-3844">
                  <CardTitle data-id="element-3845">Contact Information</CardTitle>
                  <CardDescription data-id="element-3846">How others can reach you</CardDescription>
                </CardHeader>
                <CardContent data-id="element-3847">
                  <div className="space-y-4" data-id="element-3848">
                    <div className="flex items-start" data-id="element-3849">
                      <MailIcon className="h-5 w-5 text-muted-foreground mr-3 mt-0.5" data-id="element-3850" />
                      <div data-id="element-3851">
                        <p className="text-sm font-medium" data-id="element-3852">Email Address</p>
                        <p className="text-sm text-muted-foreground" data-id="element-3853">
                          {userData.email}
                        </p>
                        <p className="text-xs text-green-600 mt-1" data-id="element-3854">
                          Primary contact method
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-3855">
                      <PhoneIcon className="h-5 w-5 text-muted-foreground mr-3 mt-0.5" data-id="element-3856" />
                      <div data-id="element-3857">
                        <p className="text-sm font-medium" data-id="element-3858">Phone Number</p>
                        <p className="text-sm text-muted-foreground" data-id="element-3859">
                          {userData.phone}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-3860">
                      <BuildingIcon className="h-5 w-5 text-muted-foreground mr-3 mt-0.5" data-id="element-3861" />
                      <div data-id="element-3862">
                        <p className="text-sm font-medium" data-id="element-3863">Company</p>
                        <p className="text-sm text-muted-foreground" data-id="element-3864">
                          {userData.company}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-3865">
                      <MapPinIcon className="h-5 w-5 text-muted-foreground mr-3 mt-0.5" data-id="element-3866" />
                      <div data-id="element-3867">
                        <p className="text-sm font-medium" data-id="element-3868">Location</p>
                        <p className="text-sm text-muted-foreground" data-id="element-3869">
                          {userData.location}
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>
            <TabsContent value="security" className="space-y-4" data-id="element-3870">
              <Card data-id="element-3871">
                <CardHeader data-id="element-3872">
                  <CardTitle data-id="element-3873">Password</CardTitle>
                  <CardDescription data-id="element-3874">
                    Change your account password
                  </CardDescription>
                </CardHeader>
                <CardContent data-id="element-3875">
                  <div className="space-y-4" data-id="element-3876">
                    <div className="space-y-2" data-id="element-3877">
                      <label htmlFor="current-password" className="text-sm font-medium" data-id="element-3878">
                        Current Password
                      </label>
                      <input id="current-password" type="password" className="w-full p-2 rounded-md border bg-background" placeholder="Enter current password" data-id="element-3879" />
                    </div>
                    <div className="space-y-2" data-id="element-3880">
                      <label htmlFor="new-password" className="text-sm font-medium" data-id="element-3881">
                        New Password
                      </label>
                      <input id="new-password" type="password" className="w-full p-2 rounded-md border bg-background" placeholder="Enter new password" data-id="element-3882" />
                    </div>
                    <div className="space-y-2" data-id="element-3883">
                      <label htmlFor="confirm-password" className="text-sm font-medium" data-id="element-3884">
                        Confirm New Password
                      </label>
                      <input id="confirm-password" type="password" className="w-full p-2 rounded-md border bg-background" placeholder="Confirm new password" data-id="element-3885" />
                    </div>
                  </div>
                </CardContent>
                <CardFooter className="border-t" data-id="element-3886">
                  <Button className="ml-auto" data-id="element-3887">Update Password</Button>
                </CardFooter>
              </Card>
              <Card data-id="element-3888">
                <CardHeader data-id="element-3889">
                  <CardTitle data-id="element-3890">Two-Factor Authentication</CardTitle>
                  <CardDescription data-id="element-3891">
                    Secure your account with 2FA
                  </CardDescription>
                </CardHeader>
                <CardContent data-id="element-3892">
                  <div className="flex items-start p-4 border rounded-md bg-green-50 dark:bg-green-900/20" data-id="element-3893">
                    <ShieldIcon className="h-5 w-5 text-green-500 mr-3 mt-0.5" data-id="element-3894" />
                    <div data-id="element-3895">
                      <p className="text-sm font-medium" data-id="element-3896">
                        Two-factor authentication is enabled
                      </p>
                      <p className="text-xs text-muted-foreground mt-1" data-id="element-3897">
                        Your account is secured with authentication app
                      </p>
                      <div className="mt-2" data-id="element-3898">
                        <Button variant="outline" size="sm" data-id="element-3899">
                          Configure 2FA
                        </Button>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
              <Card data-id="element-3900">
                <CardHeader data-id="element-3901">
                  <CardTitle data-id="element-3902">Login Sessions</CardTitle>
                  <CardDescription data-id="element-3903">Manage your active sessions</CardDescription>
                </CardHeader>
                <CardContent data-id="element-3904">
                  <div className="space-y-4" data-id="element-3905">
                    <div className="p-3 border rounded-md flex items-start" data-id="element-3906">
                      <div className="p-2 rounded-md bg-primary/10 mr-3" data-id="element-3907">
                        <LockIcon className="h-4 w-4 text-primary" data-id="element-3908" />
                      </div>
                      <div className="flex-1" data-id="element-3909">
                        <div className="flex items-center justify-between" data-id="element-3910">
                          <p className="text-sm font-medium" data-id="element-3911">
                            Chrome on Windows
                          </p>
                          <Badge data-id="element-3912">Current</Badge>
                        </div>
                        <p className="text-xs text-muted-foreground mt-1" data-id="element-3913">
                          Last active: Just now • San Francisco, CA
                        </p>
                      </div>
                    </div>
                    <div className="p-3 border rounded-md flex items-start" data-id="element-3914">
                      <div className="p-2 rounded-md bg-primary/10 mr-3" data-id="element-3915">
                        <LockIcon className="h-4 w-4 text-primary" data-id="element-3916" />
                      </div>
                      <div className="flex-1" data-id="element-3917">
                        <div className="flex items-center justify-between" data-id="element-3918">
                          <p className="text-sm font-medium" data-id="element-3919">
                            Mobile App on iPhone
                          </p>
                          <Button variant="ghost" size="sm" className="h-8 px-2" data-id="element-3920">
                            Revoke
                          </Button>
                        </div>
                        <p className="text-xs text-muted-foreground mt-1" data-id="element-3921">
                          Last active: 2 hours ago • San Francisco, CA
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
                <CardFooter className="border-t" data-id="element-3922">
                  <Button variant="outline" className="ml-auto" data-id="element-3923">
                    Logout of All Sessions
                  </Button>
                </CardFooter>
              </Card>
            </TabsContent>
            <TabsContent value="notifications" className="space-y-4" data-id="element-3924">
              <Card data-id="element-3925">
                <CardHeader data-id="element-3926">
                  <CardTitle data-id="element-3927">Notification Preferences</CardTitle>
                  <CardDescription data-id="element-3928">
                    Manage how you receive notifications
                  </CardDescription>
                </CardHeader>
                <CardContent data-id="element-3929">
                  <div className="space-y-6" data-id="element-3930">
                    {notificationPreferences.map(pref => <div key={pref.id} className="pb-5 border-b last:border-0 last:pb-0" data-id="element-3931">
                        <div className="flex items-center justify-between mb-2" data-id="element-3932">
                          <div data-id="element-3933">
                            <p className="font-medium" data-id="element-3934">{pref.category}</p>
                            <p className="text-sm text-muted-foreground" data-id="element-3935">
                              {pref.description}
                            </p>
                          </div>
                        </div>
                        <div className="flex space-x-4 mt-3" data-id="element-3936">
                          <div className="flex items-center space-x-2" data-id="element-3937">
                            <input type="checkbox" id={`${pref.id}_email`} defaultChecked={pref.email} className="rounded border-gray-300" data-id="element-3938" />
                            <label htmlFor={`${pref.id}_email`} className="text-sm" data-id="element-3939">
                              Email
                            </label>
                          </div>
                          <div className="flex items-center space-x-2" data-id="element-3940">
                            <input type="checkbox" id={`${pref.id}_push`} defaultChecked={pref.push} className="rounded border-gray-300" data-id="element-3941" />
                            <label htmlFor={`${pref.id}_push`} className="text-sm" data-id="element-3942">
                              Push
                            </label>
                          </div>
                        </div>
                      </div>)}
                  </div>
                </CardContent>
                <CardFooter className="border-t" data-id="element-3943">
                  <Button className="ml-auto" data-id="element-3944">Save Preferences</Button>
                </CardFooter>
              </Card>
              <Card data-id="element-3945">
                <CardHeader data-id="element-3946">
                  <CardTitle data-id="element-3947">Email Digest</CardTitle>
                  <CardDescription data-id="element-3948">Configure summary emails</CardDescription>
                </CardHeader>
                <CardContent data-id="element-3949">
                  <div className="space-y-4" data-id="element-3950">
                    <div className="flex items-center justify-between" data-id="element-3951">
                      <div data-id="element-3952">
                        <p className="font-medium" data-id="element-3953">Daily Summary</p>
                        <p className="text-sm text-muted-foreground" data-id="element-3954">
                          Get a daily summary of your account activity
                        </p>
                      </div>
                      <div className="flex items-center" data-id="element-3955">
                        <input type="checkbox" id="daily_digest" defaultChecked={true} className="rounded border-gray-300" data-id="element-3956" />
                      </div>
                    </div>
                    <div className="flex items-center justify-between" data-id="element-3957">
                      <div data-id="element-3958">
                        <p className="font-medium" data-id="element-3959">Weekly Market Report</p>
                        <p className="text-sm text-muted-foreground" data-id="element-3960">
                          Receive weekly insights on market trends
                        </p>
                      </div>
                      <div className="flex items-center" data-id="element-3961">
                        <input type="checkbox" id="weekly_report" defaultChecked={true} className="rounded border-gray-300" data-id="element-3962" />
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>
            <TabsContent value="activity" className="space-y-4" data-id="element-3963">
              <Card data-id="element-3964">
                <CardHeader data-id="element-3965">
                  <CardTitle data-id="element-3966">Recent Activity</CardTitle>
                  <CardDescription data-id="element-3967">
                    Your recent account activities
                  </CardDescription>
                </CardHeader>
                <CardContent data-id="element-3968">
                  <div className="space-y-4" data-id="element-3969">
                    {recentActivity.map(activity => <div key={activity.id} className="flex items-start pb-4 border-b last:border-0 last:pb-0" data-id="element-3970">
                        <ClockIcon className="h-5 w-5 text-muted-foreground mr-3 mt-0.5" data-id="element-3971" />
                        <div data-id="element-3972">
                          <p className="text-sm font-medium" data-id="element-3973">
                            {activity.action}
                          </p>
                          <p className="text-xs text-muted-foreground mt-1" data-id="element-3974">
                            {activity.timestamp} • {activity.device}
                          </p>
                          <p className="text-xs text-muted-foreground mt-0.5" data-id="element-3975">
                            IP: {activity.ipAddress}
                          </p>
                        </div>
                      </div>)}
                  </div>
                </CardContent>
                <CardFooter className="border-t" data-id="element-3976">
                  <Button variant="outline" className="ml-auto" data-id="element-3977">
                    View Full Activity Log
                  </Button>
                </CardFooter>
              </Card>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3978">
                <Card data-id="element-3979">
                  <CardHeader data-id="element-3980">
                    <CardTitle data-id="element-3981">Account History</CardTitle>
                    <CardDescription data-id="element-3982">Important account events</CardDescription>
                  </CardHeader>
                  <CardContent data-id="element-3983">
                    <div className="space-y-4" data-id="element-3984">
                      <div className="flex items-start" data-id="element-3985">
                        <UserIcon className="h-5 w-5 text-muted-foreground mr-3 mt-0.5" data-id="element-3986" />
                        <div data-id="element-3987">
                          <p className="text-sm font-medium" data-id="element-3988">Account Created</p>
                          <p className="text-xs text-muted-foreground mt-1" data-id="element-3989">
                            {userData.joinDate}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start" data-id="element-3990">
                        <ShieldIcon className="h-5 w-5 text-green-500 mr-3 mt-0.5" data-id="element-3991" />
                        <div data-id="element-3992">
                          <p className="text-sm font-medium" data-id="element-3993">
                            Account Verified
                          </p>
                          <p className="text-xs text-muted-foreground mt-1" data-id="element-3994">
                            March 20, 2022
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start" data-id="element-3995">
                        <KeyIcon className="h-5 w-5 text-blue-500 mr-3 mt-0.5" data-id="element-3996" />
                        <div data-id="element-3997">
                          <p className="text-sm font-medium" data-id="element-3998">
                            Two-Factor Authentication Enabled
                          </p>
                          <p className="text-xs text-muted-foreground mt-1" data-id="element-3999">
                            April 2, 2022
                          </p>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
                <Card data-id="element-4000">
                  <CardHeader data-id="element-4001">
                    <CardTitle data-id="element-4002">Connected Services</CardTitle>
                    <CardDescription data-id="element-4003">
                      External services linked to your account
                    </CardDescription>
                  </CardHeader>
                  <CardContent data-id="element-4004">
                    <div className="space-y-4" data-id="element-4005">
                      <div className="flex items-start p-3 border rounded-md" data-id="element-4006">
                        <div className="p-2 rounded-md bg-primary/10 mr-3" data-id="element-4007">
                          <CheckCircleIcon className="h-4 w-4 text-primary" data-id="element-4008" />
                        </div>
                        <div className="flex-1" data-id="element-4009">
                          <div className="flex items-center justify-between" data-id="element-4010">
                            <p className="text-sm font-medium" data-id="element-4011">Google</p>
                            <Button variant="ghost" size="sm" className="h-8 px-2" data-id="element-4012">
                              Disconnect
                            </Button>
                          </div>
                          <p className="text-xs text-muted-foreground mt-1" data-id="element-4013">
                            Connected on May 12, 2022
                          </p>
                        </div>
                      </div>
                      <div className="flex items-start p-3 border rounded-md" data-id="element-4014">
                        <div className="p-2 rounded-md bg-primary/10 mr-3" data-id="element-4015">
                          <AlertCircleIcon className="h-4 w-4 text-primary" data-id="element-4016" />
                        </div>
                        <div className="flex-1" data-id="element-4017">
                          <div className="flex items-center justify-between" data-id="element-4018">
                            <p className="text-sm font-medium" data-id="element-4019">Slack</p>
                            <Button variant="outline" size="sm" className="h-8 px-2" data-id="element-4020">
                              Connect
                            </Button>
                          </div>
                          <p className="text-xs text-muted-foreground mt-1" data-id="element-4021">
                            Not connected
                          </p>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>;
};
export default UserProfile;